import { InfoBox, SuccessBox } from '../..'
import { WidgetProps } from '../../widget.types'
import { WidgetTheme } from '../../WidgetTheme'
import { WidgetBox, WidgetContainer } from '../../widget.styles'

import { useThemeConfig } from '../../hooks/useThemeConfig'
import { useGetPromotionConfig } from './hooks/useGetPromotionConfig'

import { ActionButtons } from './ActionButtons'
import * as Styles from './styles'

export const GetPromotion = ({ service }: WidgetProps) => {
  const theme = useThemeConfig({ service })
  const { text, status } = useGetPromotionConfig()

  const isCompleted = status === 'completed'

  return (
    <WidgetTheme theme={theme[status]} tipOrder={1}>
      <WidgetContainer>
        <WidgetBox>
          <InfoBox text={text} isCompleted={isCompleted}>
            <ActionButtons handleClick={() => {}} />
          </InfoBox>
        </WidgetBox>
        <WidgetBox>{isCompleted ? <SuccessBox /> : <Styles.Image />}</WidgetBox>
      </WidgetContainer>
    </WidgetTheme>
  )
}
